export class AuditItemsRequest {
    idUtente: string;
    importDate: Date;
    importType: ImportTypeEnum;
    sourceCall: SourceCallEnum;

    constructor(idUtente: string, importDate: Date, importType: ImportTypeEnum, sourceCall: SourceCallEnum) {
        this.idUtente = idUtente;
        this.importDate = importDate;
        this.importType = importType;
        this.sourceCall = sourceCall;
    }
}


export class AuditRequest extends AuditItemsRequest {
    seriesNumber: number;
    filesNumber: number;
    provenance: string;
    idPatient: string;
    name: string;
    surname: string;
    birthDate: Date;
    modality: string;
    accessionNumber?: string;
    errorOnUpload?: boolean;

    constructor(idUtente: string, importDate: Date, importType: ImportTypeEnum, sourceCall: SourceCallEnum, seriesNumber: number, filesNumber: number,
        provenance: string, idPatient: string, name: string, surname: string, birthDate: Date, modality: string, accessionNumber?: string, errorOnUpload?: boolean) {

        super(idUtente, importDate, importType, sourceCall);
        this.seriesNumber = seriesNumber;
        this.filesNumber = filesNumber;
        this.provenance = provenance;
        this.idPatient = idPatient;
        this.name = name;
        this.surname = surname;
        this.birthDate = birthDate;
        this.modality = modality;
        this.accessionNumber = accessionNumber;
        this.errorOnUpload = errorOnUpload;
    }
}

export enum ImportTypeEnum {
    Dicom,
    NotDicom,
    DicomWithStudy //Dicom con prestazione
}

export enum SourceCallEnum {
    External,
    Vna,
    Refertation
}
